<template>
  <div>
    <b-modal
      ref="modal"
      title="ยืนยันการรับเงิน"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="submit"
      @hidden="reset"
    >
      <p>
        จำนวนรายการที่เลือก: <strong>{{ claimIds.length }}</strong>
      </p>
      <b-form-group label="เลขที่คำสั่งจ่าย (statement ref)" label-size="sm">
        <b-form-input v-model.trim="statementRef" placeholder="เช่น 120069MD021900034269" size="sm" />
      </b-form-group>
      <b-form-group label="ยอดเงินรวมในเอกสาร (บาท)" label-size="sm">
        <b-form-input v-model.number="depositAmount" type="number" step="0.01" size="sm" />
      </b-form-group>
      <b-form-group label="วันที่ในเอกสาร" label-size="sm">
        <b-form-input v-model="statementDate" type="date" size="sm" />
      </b-form-group>
    </b-modal>
    <Dialog ref="Dialog" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Dialog from "@/components/modal/Dialog.vue";
import { apiErrorMessage } from "@/utils/reconciliation";

export default {
  name: "MarkPaidModal",
  components: { Dialog },
  props: {
    payer: { type: String, required: true },
    // SSO: receipt payment ids · NHSO: visit (appointment) ids
    claimIds: { type: Array, required: true },
  },
  data() {
    return {
      statementRef: "",
      depositAmount: null,
      statementDate: null,
      isSubmitting: false,
    };
  },
  computed: {
    clinicUrl() {
      return this.$route.params.clinicUrl;
    },
    branchUrl() {
      return this.$route.params.branchUrl;
    },
  },
  methods: {
    ...mapActions("moduleReconciliation", ["markPaid"]),
    show() {
      this.$refs.modal.show();
    },
    reset() {
      this.statementRef = "";
      this.depositAmount = null;
      this.statementDate = null;
    },
    async submit(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (this.isSubmitting) return;
      if (this.claimIds.length === 0) {
        this.$refs.Dialog.showToast("danger", "กรุณาเลือกรายการที่ต้องการทำเครื่องหมายรับแล้ว");
        return;
      }
      this.isSubmitting = true;
      try {
        await this.markPaid({
          clinicUrl: this.clinicUrl,
          branchUrl: this.branchUrl,
          payload: {
            payer: this.payer,
            claimIds: this.claimIds,
            statementRef: this.statementRef || null,
            depositAmount: this.depositAmount,
            statementDate: this.statementDate || null,
          },
        });
        this.$refs.Dialog.showToast("success", "ทำเครื่องหมายรับแล้วสำเร็จ");
        this.$refs.modal.hide();
        this.$emit("done");
      } catch (err) {
        this.$refs.Dialog.showToast("danger", apiErrorMessage(err, "ทำเครื่องหมายรับแล้วไม่สำเร็จ กรุณาลองใหม่"));
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
